import tableContent from './tableRelatedAppContents';

export default {
  title: 'Contents',
  attributeName: 'appContent',
  getURL: 'appId/areaId/appContent',
  noArea:true,
  noTitle:true,
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId', 'areaId'],
  tableConfig: tableContent,
  autoUpdate: true,

};
